import {
  CRow,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
} from '@coreui/react-pro'
import React, { useState } from 'react'
import PlayerProfileListing from './PlayerProfileListing'
import TeamPlayerImage from './TeamPlayerImage'
import PlayerBulkImageUpload from './PlayerBulkImageUpload'
import PlayerPositionBulkUpload from './PlayerPositionBulkUpload'
import TeamSponsorLogo from './TeamSponsorLogo'

const PlayerProfile = () => {
  const [users, setUsers] = useState([])
  const [refreshKey, setRefreshKey] = useState(0)

  return (
    <>
      <CRow>
        <CAccordion activeItemKey={2}>
          <CAccordionItem itemKey={2}>
            <CAccordionHeader>
              {' '}
              <strong>Bulk Upload (By Players)</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <PlayerBulkImageUpload setRefreshKey={setRefreshKey} />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
      </CRow>
      <CRow>
        <CAccordion activeItemKey={2}>
          <CAccordionItem itemKey={2}>
            <CAccordionHeader>
              {' '}
              <strong>Bulk Upload (By Position)</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <PlayerPositionBulkUpload setRefreshKey={setRefreshKey} />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
      </CRow>
      <CRow>
        <CAccordion activeItemKey={2}>
          <CAccordionItem itemKey={2}>
            <CAccordionHeader>
              {' '}
              <strong>Bulk Upload (By Team)</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <TeamPlayerImage setRefreshKey={setRefreshKey} />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
      </CRow>
      <CRow>
        <CAccordion activeItemKey={2}>
          <CAccordionItem itemKey={2}>
            <CAccordionHeader>
              {' '}
              <strong>By Team Sponsor</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <TeamSponsorLogo setRefreshKey={setRefreshKey} />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
      </CRow>
      <CRow>
        <CAccordion activeItemKey={2}>
          <CAccordionItem itemKey={2}>
            <CAccordionHeader>
              {' '}
              <strong>Manage Players Profile</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <PlayerProfileListing users={users} setUsers={setUsers} refreshKey={refreshKey} />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
      </CRow>
    </>
  )
}

export default PlayerProfile
